import './TopBar.scss'

import Menu, { MenuItem } from '../../components/Menu/Menu'
import React, { Fragment, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Avatar from '../../components/Avatar/Avatar'
import Button from '../../components/Button/Button'
import Dropdown from '../../components/Dropdown/Dropdown'
import Icon from '../../components/Icon/Icon'
import { ReactComponent as Logo } from '../../icons/general/logo.svg'
import TextField from '../../components/TextField/TextField'
import { get } from '../../helpers/request'
import t from '../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const TopBar = ({ history }) => {
  const profile = useSelector(state => state.profile)
  const dispatch = useDispatch()

  const handleLogout = useCallback(() => {
    get('/logout').then(response => {
      dispatch({ type: 'clear-profile' })
      history.push('/')
    }).catch(error => {
      // TODO: handle logout error
    })
  }, [history, dispatch])

  return (
    <div className="top-bar">
      <div className="-logo"><Logo/></div>
      {profile.products.BETA &&
        <div className="-search"><TextField mode="simple" size="field-sized" placeholder={t('placeholders.Search_SportsProX')}/></div>
      }
      <div className="-menu">
        {profile.products.BETA &&
          <Fragment>
            <Button type="dark" label={t('buttons.Network')} />
            <Button type="dark" label={t('buttons.Community')} />
          </Fragment>
        }
      </div>
      {profile.products.BETA &&
        <Fragment>
          <div className="-icons">
            <Button type="dark" size='large' icon="ConversationsIcon" />
            <Button type="dark" size='large' icon="NotificationsIcon" />
          </div>
        </Fragment>
      }
      <Dropdown button={<ProfileButton name={profile.firstname + ' ' + profile.lastname} />}>
        <Menu colorfull>
          {profile.products.ADMIN && <MenuItem title={t('menu.General_Settings')} link="/admin" />}
          {profile.products.OLD_DELEGATE && <MenuItem title={t('menu.Registration_of_Players')} icon="DelegatesIcon" link="/cm/delegate" />}
          {profile.products.SOCCER && <MenuItem title={t('menu.Competition_Manager')} icon="WebsiteIcon" link="/soccer" />}
          <MenuItem title={t('menu.Exit')} icon="LogOutIcon" onClick={handleLogout} />
        </Menu>
      </Dropdown>
    </div>
  )
}

const ProfileButton = ({ avatar, name }) => {
  return (
    <div className='-profile'>
      <div className='-picture'>
        <Avatar source={avatar} alternative={name} size='field-sized' />
      </div>
      <div className='-name proper-noun-small-medium'>{name}</div>
      <div className='-indicator'>
        <Icon size={14} icon='ArrowDownIcon' />
      </div>
    </div>
  )
}

export default withRouter(TopBar)
